// 共通: モバイル prototype 群で使う「対象月」「期間」のデフォルト
// PC 版 store と独立 (prototype は LocalStorage 経由で個別に状態保持)。
// AsOfMonth は API の meta.dateMax を使う想定。

import { useQuery } from "@tanstack/react-query";
import { api } from "../../lib/api";
import { gpText } from "../../lib/gpMode";

export function useMeta() {
  return useQuery({
    queryKey: ["meta"],
    queryFn: api.meta,
    staleTime: Infinity,
  });
}

// PC 版と同じ KPI 9 指標 (順序固定)
export const TOP9_METRICS = [
  "入院収入", "入院患者延数", "入院単価",
  "新規入院数", "新規受持数", "退院患者数",
  "平均在院日数", "GP", "GP単価",
];

// 表示用ラベル
export const METRIC_DISPLAY: Record<string, string> = {
  "入院単価": "1日入院単価",
  "GP": "粗利",
  "GP単価": "1日粗利単価",
  "DPC期間2以内率": "DPCⅡ以内率",
  "常勤換算数": "常勤医師数(入院診療科)",
};
export const ml = (m: string): string => gpText(METRIC_DISPLAY[m] ?? m);

// アラート 6 カテゴリ (PC 版 AlertsPanel と同じ)
export const ALERT_CATEGORIES = [
  { key: "budgetUnder",    label: "予算未達",   metric: "入院収入",     unit: "千円", icon: "💰" },
  { key: "yoyDown",        label: "前年比低下", metric: "入院収入",     unit: "千円", icon: "📉" },
  { key: "volDown",        label: "患者数減少", metric: "入院患者延数", unit: "人日", icon: "👥" },
  { key: "priceDown",      label: "単価低下",   metric: "入院単価",     unit: "円/日", icon: "💴" },
  { key: "newPatientDown", label: "新規入院減", metric: "新規入院数",   unit: "件",   icon: "🆕" },
  { key: "stayUp",         label: "在院長期化", metric: "平均在院日数", unit: "日",   icon: "⏰" },
] as const;
